import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { createQueryParams, IGlobalSearchResult } from '@inshuwa-client/models';
import { baseUrl } from '../configs/baseUrl';
import { SKIP_ERROR_TOAST } from '../interceptors/ic-http-interceptor.interceptor';

@Injectable({
  providedIn: 'root',
})
export class GlobalSearchService {
  private readonly http = inject(HttpClient);

  search(query: string): Observable<IGlobalSearchResult[]> {
    return this.http.get<IGlobalSearchResult[]>(`${baseUrl()}/search`, {
      params: createQueryParams({ query }),
      // Type-ahead search fails inline (command palette shows its own error state) —
      // suppress the global error toast so it doesn't fire on every keystroke hiccup.
      context: new HttpContext().set(SKIP_ERROR_TOAST, true),
    });
  }
}
